module.exports = __webpack_public_path__ + "static/img/failImg.8bc92f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/failImg.jpg
// module id = 52
// module chunks = 1